import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type EmptyStateProps = {
  image: string;
  title: string;
  message: string;
  action?: ReactNode;
};

const EmptyState = ({ image, title, message, action }: EmptyStateProps) => (
  <Stack alignItems="center" textAlign="center" gap={3} sx={{ paddingX: 8, paddingTop: '18vh', paddingBottom: 8 }}>
    <Box component="img" src={image} alt="" sx={{ width: 136, height: 140, marginBottom: 2 }} />
    <Typography sx={{ fontSize: 24, fontWeight: 800, letterSpacing: '-0.01em', lineHeight: 1.2 }}>{title}</Typography>
    <Typography sx={{ fontSize: 16, color: 'text.secondary', maxWidth: 320 }}>{message}</Typography>
    {action}
  </Stack>
);

export default EmptyState;
